import firebase from "firebase/app"
import "firebase/storage"

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDBYkxXJA2y07DeCHQ1orN1DWcASjDN2Gc",
  authDomain: "slapdigitalcv.firebaseapp.com",
  databaseURL: "https://slapdigitalcv.firebaseio.com",
  projectId: "slapdigitalcv",
  storageBucket: "slapdigitalcv.appspot.com",
  messagingSenderId: "683700285115",
  appId: "1:683700285115:web:e9539c95fd76d3f8d1039e",
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const storage = firebase.storage()

export { storage, firebase as default }
